import * as React from "react";
import defaultAttributes from "./defaultAttributes";

export type IconNode = [
  elementName: keyof React.ReactSVGElement,
  attrs: Record<string, string>,
][];

type SVGAttributes = Partial<React.SVGProps<SVGSVGElement>>;
type ComponentAttributes = React.RefAttributes<SVGSVGElement> & SVGAttributes;

export interface MeisterIconsProps extends ComponentAttributes {
  size?: string | number;
}

export type MeisterIcon = React.ForwardRefExoticComponent<MeisterIconsProps>;

const toCamelCase = (string: string) =>
  string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2) =>
    p2 ? p2.toUpperCase() : p1.toLowerCase()
  );

const toPascalCase = (string: string) =>
  toCamelCase(string).charAt(0).toUpperCase() + toCamelCase(string).slice(1);

const createMeisterIcons = (
  iconName: string,
  iconNode: IconNode
): MeisterIcon => {
  const Component = React.forwardRef<
    Omit<MeisterIconsProps, "ref"> & React.RefAttributes<SVGSVGElement>
  >(({ color = "currentColor", size = 24, children, ...rest }: any, ref: any) =>
    React.createElement(
      "svg",
      {
        ref,
        width: size,
        height: size,
        className: `mni mni-${iconName}`,
        color,
        ...defaultAttributes,
        ...rest,
      },
      [
        ...iconNode.map(([tag, attrs]) => React.createElement(tag, attrs)),
        ...(Array.isArray(children) ? children : [children]),
      ]
    )
  );

  Component.displayName = toPascalCase(iconName);

  return Component;
};

export default createMeisterIcons;
